import React, { useState, useEffect } from 'react';
import LeaseApiService from '../../services/apiService';
import { FaSave, FaChevronLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { ClipLoader } from 'react-spinners';
import { useTranslation } from 'react-i18next';
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';
import { getCountryFromCurrency } from '../../../INVENTORY/Layouts/currencyHelpers';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { getCompany, getName } from '../../../Redux/selecters';
import MasterDetails from './masterDetails';
import UnitDetails from './unitDetails';
import ImagesList from './images';
import SalesDetails from './salesDetails';
import BuyerSummery from './buyerSummery';
import moment from 'moment/moment';
import LeaseDetails from './leaseDetails';
import UnitFeature from './unitFeatures';
import axios from 'axios';
import { endPoint } from '../../EndPoints/endPoint';
import '../customerMaster/customerForm.css';
import StepForm from '../shared/stepForm';

const createEmptyRow = () => ({
  id: Date.now() + Math.random(),
  file: null, // for new file (File object)
  fileName: '',
  filePath: '',
  remarks: '',
  isNew: true, // ✅ identify new file
  fullUrl: '', // ✅ for existing file preview
});

const CreateUnitMaster = ({ onClose, onSaved } = {}) => {
  const { t } = useTranslation();
  const apiService = new LeaseApiService();
  let navigate = useNavigate();
  const userName = useSelector(getName);
  const [activeFY, setActiveFY] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const [gridVisibility, setGridVisibility] = useState([true, false, false, false, false, false, false, false]);
  const [loading, setloader] = useState(false);
  // Master Listings
  const [bedRoomList, setBedRoomList] = useState([]);
  const [propertyList, setPropertyList] = useState([]);
  const [contactPerson, setContactPerson] = useState([]);
  const [unitTypeList, setUnitTypeList] = useState([]);
  const [unitViewList, setunitViewList] = useState([]);
  const [landlordList, setLandlordList] = useState([]);

  const [unitCategoryList, setunitCategoryList] = useState([]);
  const [floorList, setFloorList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  // Unit Listings
  const [furnishing, setFurnishing] = useState([]);
  const [featuresList, setFeaturesList] = useState([]);
  const [attachments, setAttachments] = useState([createEmptyRow()]);
  const [supplierCheck, setSupplierCheck] = useState('');
  const [leaseCheck, setLeaseCheck] = useState([]);

  const today = new Date();
  const formattedDate = today.toISOString().split('T')[0]; // DD-MMM-YYYY
  const formatDate = (date) => {
    return moment(date).format('DD-MMM-YYYY');
  };

  const validationRules = [
    { key: 'property', message: 'Please Select Property' },
    { key: 'unitNo', message: 'Please Enter Unit No' },
    { key: 'unitType', message: 'Please Enter Unit Type' },
    { key: 'unitCategory', message: 'Please Enter Unit Category' },
  ];
  const [transectionData, setTransectionData] = useState({
    property: null,
    unitType: null,
    unitCategory: null,
    contactPerson: null,
    unitNo: '',
    roundoff: '',
    notes: '',
    totalvalue: '',
    mobile: '',
  });
  const [unitDetails, setUnitDetails] = useState({
    bedRooms: null,
    unitView: null,
    furnishing: null,
    utilityRoom: '',
    studyRoom: '',
    laundryRoom: '',
    maidRoom: '',
    storeRoom: '',
    plotNO: '',
    bathRoom: '',
    plotSize: '',
    parking: '',
    balcony: '',
    parkingPrice: '',
    totalArea: '',
    rent: '',
    sqftRate: '',
    allPrice: '',
    allPriceBase: '',
    registrationFee: '4',
    saller: null,
    landlordId: null,
    completionDate: formattedDate,
  });
  const [salesDetails, setSalesDetails] = useState({
    currency: null,
    orignalPrice: '',
    orignalRateSqft: '',
    profit: '',
    profitCalculate: '',
    listingPrice: '',
    listingPriceRate: '',
    priceinothercontry: '',
    mainSalePrice: '',
    marketAnalysis: '',
    to: '',
    commPaid: '',
    commPaidCalculate: '',
    commSeller: '',
    commSellerCalculate: '',
    sellerTransferFee: '',
    sellerTransferFeeCalcu: '',
    buyerTransferFee: '',
    buyerTransferFeeCalcu: '',
    legalFee: '',
    legalFeeCalcu: '',
    miscFee: '',
    miscFeeCalcu: '',
    comment: '',
    sellerPaidDev: '',
    sellerPaidDevCalcu: '',
    amountDueDev: '',
    amountDueDevCalcu: '',
  });
  const [buyerSummery, setBuyerSummery] = useState({
    sellerTransfer: '',
    developerBalance: '',
    developerBalancePerc: '',
    BuyerCommission: '',
    BuyerCommissionPerc: '',
    DlDTransfer: '',
    DlDTransferPerc: '',
    administrationFee: '',
    administrationFeePerc: '',
    otherFee: '',
    otherFeePerc: '',
    allPrice: '',
    allPricePerc: '',
  });
  const [leaseDetails, setLeaseDetails] = useState({
    dueDate: formattedDate,
    rentPerAnum: '',
    rentByMonth: '',
    rentPerDay: '',
    securityDeposit: '',
    securityDepositPerc: '',
    tenantCommission: '',
    tenantCommissionPerc: '',
    landlordCommission: '',
    landlordCommissionPerc: '',
    maintenanceFee: '',
    rentPayable: '',
    IbanNo: '',
    secDepositPayable: '',
    commissionPayable: '',
    bankName: null,
    accountNo: '',
    fixedCharges: '',
    variableCharges: '',
    installment: '',
  });

  useEffect(() => {
    fetchDropdownData();
    const financialYears = JSON.parse(localStorage.getItem('financialYear')) || [];
    const activeFinancialYear = financialYears?.find((fy) => fy.isActive);
    if (activeFinancialYear) {
      setActiveFY({ label: activeFinancialYear.name, value: activeFinancialYear });
    }
  }, []);
  const fetchDropdownData = async () => {
    try {
      const params = new URLSearchParams();
      params.append('dropdownTypes', 'UMProperties,UMFloors,UMUnitViews,UMSellers,UMUnitTypes,UMUnitCategories,UMFurnishing,UMBedrooms,UMAgents');
      const res = await apiService.getApiParamater('GET_UNIT_MULTIDROP', `?${params.toString()}`);
      setFloorList(res?.data?.dropdowns?.UMFloors);
      setPropertyList(res?.data?.dropdowns?.UMProperties);
      setunitCategoryList(res?.data?.dropdowns?.UMUnitCategories);
      setunitViewList(res?.data?.dropdowns?.UMUnitViews);
      setUnitTypeList(res?.data?.dropdowns?.UMUnitTypes);
      setFurnishing(res?.data?.dropdowns?.UMFurnishing);
      setBedRoomList(res?.data?.dropdowns?.UMBedrooms);
      setContactPerson(res?.data?.dropdowns?.UMAgents);
      setLandlordList(res?.data?.dropdowns?.UMSellers);
    } catch (error) {
      console.error('Error fetching dropdown data:', error);
    }
  };
  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
    const newGridVisibility = gridVisibility.map((_, index) => index === tabIndex);
    setGridVisibility(newGridVisibility);
  };
  const handleBackClick = () => {
    if (onClose) {
      onClose();
      return;
    }
    window.history.back();
  };
  const handleSave = async () => {
    try {
      setloader(true);
      for (const rule of validationRules) {
        if (!transectionData?.[rule.key]) {
          setloader(false);
          toast.warning(rule.message);
          return;
        }
      }
      const scndparams = new URLSearchParams();
      scndparams.append('Action', 'CheckDuplicateUnit');
      scndparams.append('PropertyNo', transectionData?.property?.value?.value);
      scndparams.append('UnitNo', transectionData?.unitNo);
      const scndRes = await apiService.getApiParamater('GET_UNIT_COMMON', `?${scndparams.toString()}`);
      const duplicateCheck = scndRes?.data?.result?.data?.[''];

      if (duplicateCheck === 1) {
        toast.warning('Unit already exists for this property');
        setloader(false);
        return;
      }
      const unitFeatures = featuresList?.map((item, index) => {
        return {
          status: item?.DescType || '0',
          description: item?.Description || '0',
          value: item?.Value,
          cnt: parseFloat(item?.Cnt) || 0,
          amount: parseFloat(item?.Amount) || 0,
          isNewInEdit: item?.IsNewInEdit === 0 ? false : true,
        };
      });
      const selectedchecks = leaseCheck.join("/");
      const body = {
        unitMasterMain: {
          unitMaster: {
            ref_No: '0',
            property_No: transectionData?.property?.value?.value || '0',
            property_Name: transectionData?.property?.label || '0',
            unit_No: transectionData?.unitNo || '0',
            rerA_STR_No: '0',
            street_No: unitDetails?.utilityRoom || '0',
            street_Name: unitDetails?.laundryRoom || '0',
            unit_Type: transectionData?.unitType?.label || '0',
            unit_Category: transectionData?.unitCategory?.label || '0',
            unit_Style: '0',
            unit_Model: '0',
            unit_Zone: '0',
            usp: selectedchecks,
            plot_No: unitDetails?.plotNO || '0',
            plot_Size: unitDetails?.plotSize || '0',
            block: '0',
            floor: unitDetails?.floor?.label || '0',
            unit_View: unitDetails?.unitView?.label || '0',
            completion_Date: unitDetails?.completionDate,
            unit_Class: supplierCheck || '0',
            livingRooms: '0',
            bedrooms: unitDetails?.bedRooms?.label || '0',
            storeRooms: unitDetails?.maidRoom || '0',
            parking: unitDetails?.parking || '0',
            facilities: unitDetails?.furnishing?.label || '0',
            status: '0',
            payment_Plan: '0',
            broker_Name: transectionData?.contactPerson?.label || '0',
            seller_Id: unitDetails?.landlordId?.label || '0',
            seller_Name: unitDetails?.saller?.label || '0',
            adv_Listing: true,
            adv_OpenHouse: true,
            adv_Remarks1: '0',
            adv_Remarks2: '0',
            adv_Remarks3: '0',
            remarks: transectionData?.notes || '0',
            internalRemarks: '0',
            otherSpace1: '0',
            bathrooms: unitDetails?.bathRoom || '0',
            balcony: unitDetails?.balcony || '0',
            terrace: '0',
            total_Area: parseFloat(unitDetails?.totalArea) || 0,
            measured_Area: 0,
            sqft_Rate: parseFloat(unitDetails?.sqftRate || 0),
            purchase_Value: 0,
            total_Value: parseFloat(transectionData?.totalvalue || 0),
            measured_Value: 0,
            roundOff_Value: parseFloat(transectionData?.roundoff || 0),
            parking_Price: parseFloat(unitDetails?.parkingPrice) || 0,
            all_In_Price: parseFloat(unitDetails?.allPrice || 0),
            premium: 0,
            premium_Percent: 0,
            seller_Commission: 0,
            seller_Commission_Percent: 0,
            buyer_Commission: 0,
            buyer_Commission_Percent: 0,
            seller_TransferFee: 0,
            seller_TransferFee_Percent: 0,
            buyer_TransferFee: parseFloat((((parseFloat(unitDetails?.allPriceBase ?? unitDetails?.allPrice) || 0) * (parseFloat(unitDetails?.registrationFee) || 0)) / 100).toFixed(2)),
            buyer_TransferFee_Percent: parseFloat(unitDetails?.registrationFee || 0),
            admin_Fees: 0,
            admin_Fees_Percent: 0,
            other_Fees: 0,
            other_Fees_Percent: 0,
            other_Fees_Remarks: '0',
            seller_Paid: 0,
            seller_Paid_Percent: 0,
            developer_Due: 0,
            developer_Due_Percent: 0,
            rent_Per_Annum: parseFloat(unitDetails?.rent || 0),
            short_Term_Rent: 0,
            short_Term_Period: '0',
            rent_Per_Day: 0,
            security_Deposit: 0,
            advance_Deposit: 0,
            tenant_Commission: 0,
            landlord_Commission: 0,
            maintenance_Fee: 0,
            negotiable: true,
            currency: '0',
            cmA_Range1: 0,
            cmA_Range2: 0,
            installments: 0,
            rentPayableTo: '0',
            rentBankName: '0',
            rentBankAcNo: '0',
            secDepPayableTo: '0',
            comPayableTo: '0',
            key_Status: '0',
            publishStatus: true,
            serviceCharge: '0',
            ownerOccupied: true,
            leased: supplierCheck === 'Lease' ? true : false,
            leaseAmount: 0,
            leaseExpiry: unitDetails?.expiryDate,
            mandate: '0',
            financeCompany: unitDetails?.studyRoom || '0',
            mortgaged: true,
            mortgageCompany: '0',
            propertyRegistered: true,
            portfolio: 0,
            portfolioManager: '0',
            propertyType: '0',
            factor: 0,
            common: 0,
            cp: 0,
            effeciency: '0',
            listingPriceUSD: 0,
            monthlyIncome: '0',
            annualIncome: '0',
            exp9: '0',
            exp10: '0',
            refered_By: '0',
            refered_On: unitDetails?.reffferedDate,
            createdBy: userName || '0',
            createdOn: today,
            modifiedBy: userName || '0',
            modifiedOn: today,
          },
          unitFeatures: unitFeatures,
          unitImages: [
            {
              record_Id: 0,
              image_Description: '0',
              image_Filename: '0',
              isDefault: true,
              folder: '0',
              url: '0',
              isAdded: false,
              isUpdated: false,
              isDeleted: false,
            },
          ],
          unitPayables: [
            {
              description: '0',
              value: true,
              landlord: true,
              tenant: true,
            },
          ],
          unitYearlyRents: [
            {
              year: 0,
              rentPerSqftRest: 0,
              rentPerSqftKitchen: 0,
              rentPerSqftTerrace: 0,
              totalRent: 0,
              scPerSqftRest: 0,
              scPerSqftKitchen: 0,
              scPerSqftTerrace: 0,
              totalServiceCharge: 0,
              chilledWaterPerSqftRest: 0,
              chilledWaterPerSqftKitchen: 0,
              chilledWaterPerSqftTerrace: 0,
              totalChilledWaterCharge: 0,
            },
          ],
          unitFixedCharges: [
            {
              description: '0',
              amount: 0,
            },
          ],
        },
      };
      const postRes = await apiService.post('CREATE_UNIT', body);
      // Same fix as updateUnitMaster.js: don't rely solely on a statusCode
      // field inside the JSON body - a 204 No Content response has no body
      // at all, which silently skipped this whole branch (and with it,
      // handleUpload - the image upload never even ran). Note a genuine 204
      // here would still leave no way to get the newly created unit's
      // ref_No for handleUpload below, since CREATE_UNIT has to return that
      // in its body - there's no way around needing a body on create.
      const isSaveSuccessful = [200, 201, 204].includes(postRes?.status) || [200, 201].includes(postRes?.data?.statusCode);
      if (isSaveSuccessful) {
        if (attachments) {
          // Keep this failure separate from the unit-save success below - the
          // unit record itself already saved fine at this point, so an image
          // upload failure shouldn't look like nothing happened at all.
          try {
            await handleUpload(postRes?.data?.result?.ref_No);
          } catch (uploadError) {
            console.error('Error uploading unit images', uploadError);
            toast.warning(uploadError?.message || 'Unit saved, but the image upload failed. Please try uploading the image again.');
          }
        }
        toast.success(postRes?.data?.message || 'Unit created successfully.');
        setloader(false);
        if (onSaved) {
          onSaved();
        } else {
          navigate('/Customer/Property/Master/Unit/Listing');
        }
      } else {
        toast.warning(postRes?.data?.message || 'Failed to create unit. Please try again.');
        setloader(false);
      }
    } catch (error) {
      console.error('Error Save Data', error);
      // Previously silent: this catch never showed the user anything, so a
      // thrown/network/validation error on the save call itself (before
      // postRes even comes back) looked exactly like clicking Save did
      // nothing at all.
      toast.error(error?.response?.data?.message || error?.message || 'Failed to save unit. Please try again.');
      setloader(false);
    } finally {
      setloader(false);
    }
  };
  const handleUpload = async (ref_No) => {
    const formData = new FormData();

    let token = localStorage.getItem('Token');
    let db = localStorage.getItem('DataBase');
    // const validFiles = attachments.filter(
    //     (item) => item.file instanceof File
    // );
    const validFiles = attachments.filter((item) => item.file instanceof File && item.isNew);
    if (!validFiles.length) return;

    validFiles.forEach(({ file }) => {
      formData.append('files', file);
    });

    formData.append('refNo', ref_No);
    formData.append('fileCategory', 'Images');

    const response = await axios.post(endPoint.UNIT_FILE, formData, {
      headers: {
        accept: 'text/plain',
        apikey: 'V+kBloEwqqVho1PINmQI0VJQwSBX2l/e',
        Authorization: `Bearer ${token}`,
        db: db,
      },
    });
    // The upload call itself succeeding (HTTP 200) doesn't mean the file was
    // actually saved - the API can still return isSuccessful: false with no
    // result rows. That was never checked before, so a failed upload fell
    // through to additionalDataUpload below with an empty/undefined result:
    // it still ran and still "succeeded", just with no image records in the
    // body it posted - the unit saved with zero images attached and no error
    // anywhere. Same check already proven in customerDocumentHelpers.js's
    // uploadCustomerDocuments for the same UNIT_FILE endpoint.
    const results = response?.data?.result || [];
    if (!response?.data?.isSuccessful && !results.length) {
      throw new Error(response?.data?.message || 'Image upload failed');
    }
    // The upload API only returns file storage metadata (fileName, filePath,
    // fullUrl, ...) - it never sees the row's own Remarks input, since that's
    // a purely frontend field never sent to it. Pair each result back with
    // the row it came from (by position - same order-preserving convention
    // already used for this same upload endpoint in
    // customerDocumentHelpers.js's uploadCustomerDocuments) so
    // additionalDataUpload can use that row's remarks as the image
    // description.
    const resultsWithRemarks = results.map((result, index) => ({ ...result, remarks: validFiles[index]?.remarks || '' }));
    await additionalDataUpload(resultsWithRemarks, ref_No);
  };
  const additionalDataUpload = async (data, refNo) => {
    const unitFeatures = featuresList?.map((item, index) => {
      return {
        status: item?.DescType || '0',
        description: item?.Description || '0',
        value: item?.Value,
        cnt: parseFloat(item?.Cnt) || 0,
        amount: parseFloat(item?.Amount) || 0,
        isNewInEdit: item?.IsNewInEdit === 0 ? false : true,
      };
    });
    // Pass the upload response straight through - Url is the file's real
    // fullUrl from UNIT_FILE (where the bytes actually live), not a
    // constructed path. Folder gets sent too, but the backend hardcodes it
    // to refNo regardless (confirmed in UnitManagementRepository.cs's
    // InsertUnitImages/UpdateUnitImages) - included here only because the
    // DTO has the field, not because this value is what ends up stored.
    const image = data?.map((item, index) => {
      const description = item?.remarks || item?.originalFileName || 'Image';
      return {
        record_Id: 0,
        image_Description: description,
        image_Filename: item?.fileName || '0',
        isDefault: false,
        folder: item?.filePath || '0',
        url: item?.fullUrl || '0',
        isAdded: true,
        isUpdated: false,
        isDeleted: false,
      };
    });
    const body = {
      refNo: refNo || '0',
      unitFeatures: unitFeatures,
      unitImages: image,
      propertyNo: transectionData?.property?.value?.value || '0',
      unitPayables: [
        {
          description: '0',
          value: true,
          landlord: true,
          tenant: true,
        },
      ],
      unitYearlyRents: [
        {
          year: 0,
          rentPerSqftRest: 0,
          rentPerSqftKitchen: 0,
          rentPerSqftTerrace: 0,
          totalRent: 0,
          scPerSqftRest: 0,
          scPerSqftKitchen: 0,
          scPerSqftTerrace: 0,
          totalServiceCharge: 0,
          chilledWaterPerSqftRest: 0,
          chilledWaterPerSqftKitchen: 0,
          chilledWaterPerSqftTerrace: 0,
          totalChilledWaterCharge: 0,
        },
      ],
      unitFixedCharges: [
        {
          description: '0',
          amount: 0,
        },
      ],
    };
    const postRes = await apiService.post('POST_UNIT_ADDITIONAL', body);
  };
  return (
    <StepForm
      title={t('unitMaster.addFormTitle')}
      chip={transectionData?.unitNo || 'New unit'}
      subtitle="Capture the unit once; leases, sales and documents link back here."
      steps={[
        { key: 0, label: t('unitMaster.tabs.propertyDetails') },
        { key: 1, label: t('unitMaster.tabs.unitDetails') },
        { key: 2, label: t('unitMaster.tabs.unitFeatures'), count: featuresList?.length || 0 },
        { key: 7, label: t('unitMaster.tabs.images') },
      ]}
      activeKey={activeTab}
      onStep={handleTabClick}
      onBack={handleBackClick}
      onSave={handleSave}
      saving={loading}
      saveLabel={t('common.add')}
    >
        {/* Lease Details */}
        {gridVisibility[0] && (
          <MasterDetails
            tableLoading={tableLoading}
            contactPerson={contactPerson}
            setTransectionData={setTransectionData}
            propertyList={propertyList}
            setFeaturesList={setFeaturesList}
            transectionData={transectionData}
            unitTypeList={unitTypeList}
            unitCategoryList={unitCategoryList}
            setunitCategoryList={setunitCategoryList}
          />
        )}
        {gridVisibility[1] && (
          <UnitDetails
            tableLoading={tableLoading}
            bedRoomList={bedRoomList}
            supplierCheck={supplierCheck}
            setTransectionData={setUnitDetails}
            furnishing={furnishing}
            setSupplierCheck={setSupplierCheck}
            setLeaseCheck={setLeaseCheck} leaseCheck={leaseCheck}
            floorList={floorList}
            transectionData={unitDetails}
            unitViewList={unitViewList} landlordList={landlordList}
          />
        )}
        {gridVisibility[2] && <UnitFeature tableLoading={tableLoading} setFeaturesList={setFeaturesList} featuresList={featuresList} />}
        {gridVisibility[7] && <ImagesList attachments={attachments} setAttachments={setAttachments} createEmptyRow={createEmptyRow} />}
    </StepForm>
  );
};
export default CreateUnitMaster;
